<template>
  <div class="eventos-participantes">
    <app-search-bar/>
    
    <b-row>
      <b-col cols="12" xl="12">  
        <b-card header="Datos del Evento">
          <b-form>
            <b-form-group
              label="Cliente"
              label-for="cliente"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="cliente"
                :value="clienteNombre"
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Evento"
              label-for="evento"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="evento"
                :value="eventoNombre"
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>
          </b-form>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">
        <app-filtro
          :nombre="nombre"
          :documentoNumero="documentoNumero"
          :documentoNumeroHabilitado="documentoNumeroHabilitado"
          :email="email"
          :emailHabilitado="emailHabilitado"
          :numeroCelular="numeroCelular"
          :numeroCelularHabilitado="numeroCelularHabilitado"
          :negocio="negocio"
          :cuitNegocio="cuitNegocio"
          :negocioHabilitado="negocioHabilitado"
          :codigoPromocion="codigoPromocion"
          :codigoPromocionHabilitado="codigoPromocionHabilitado"
          :numeroCliente="numeroCliente"
          :numeroClienteHabilitado="numeroClienteHabilitado"
          @filtrar="filtrar">
        </app-filtro>  
      </b-col>      
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
          <b-card header="Listado de Participantes">
            <!-- <b-form>
              <b-form-group
                label="Evento"
                label-for="evento"
                :label-cols="labelCols"
                horizontal>
                <b-form-input 
                  id="evento"
                  :value="evento"
                  type="text"
                  readonly>
                </b-form-input>
              </b-form-group>
            </b-form> -->

            <b-table hover
                responsive="sm" 
                :class="{ 'registro': true, 
                  'evento-pwa': tipoEventoId == 1 ? true : false }"
                :busy="tableBusy"
                :items="participantes" 
                :fields="participantesFields" 
                @row-clicked="consultar">
              <div slot="table-busy" class="text-center">
                <b-spinner class="table-spinner" label="Spinning" />
              </div>
              <template v-slot:cell(fechaNacimiento)="data">
                {{ data.item.fechaNacimiento | fecha }}
              </template>
              <template v-slot:cell(confirmado)="data">
                {{ data.item.confirmado? 'Si' : 'No' }}
              </template>
              <template v-slot:cell(esCliente)="data">
                {{ data.item.esCliente? 'Si' : 'No' }}
              </template>
              <template v-slot:cell(staff)="data">
                {{ data.item.staff? 'Si' : 'No' }}
              </template>
              <template v-slot:cell(opciones)="data">
                <b-dropdown 
                    v-if="agregarHabilitado"
                    variant="link" toggle-class="text-decoration-none" no-caret>
                  <template slot="button-content">
                    <i class="fa fa-ellipsis-v"></i>
                  </template>
                  <b-dropdown-item 
                      v-if="agregarHabilitado & editarHabilitado"
                      @click.stop="editarItem(data.item)">
                    <i class="fa fa-edit"></i>Editar Datos del Participante</b-dropdown-item>
                  <b-dropdown-item 
                      v-if="agregarHabilitado & borrarHabilitado"
                      @click.stop="borrarItem(data.item)">
                    <i class="fa fa-remove"></i>Borrar Participante</b-dropdown-item>
                </b-dropdown>
              </template>            
            </b-table>
            <nav>
              <b-pagination size="sm" 
                :total-rows="totalRegistros" 
                :per-page="registrosPorPagina" 
                v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
            </nav>
          </b-card>
        </transition>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>
          
          <b-dropdown-item 
              v-if="agregarHabilitado"
              @click.stop="agregarParticipante">
            <i class="fa fa-plus"></i>Nuevo Participante</b-dropdown-item>

          <b-dropdown-item 
              v-if="importaParticipantes || importaGanadores"
              @click.stop="importarParticipantes">
            <i class="fa fa-plus"></i>Importar Participantes</b-dropdown-item>

          <b-dropdown-item 
              v-if="(importaParticipantes || importaGanadores) && tieneImportsPendientes"
              @click.stop="consultarImports">
            <i class="fa fa-list"></i>Consultar Imports del Evento</b-dropdown-item>

          <!-- <b-dropdown-item 
              v-if="agregarHabilitado"
              @click.stop="agregarParticipanteReinscripcion">
            <i class="fa fa-plus"></i>Nueva Participación (Reinscripción)</b-dropdown-item> -->

          <b-dropdown-item @click.stop="exportParticipantes">
            <i class="fa fa-file-excel-o"></i>Exportar Listado</b-dropdown-item>

          <b-dropdown-item @click.stop="goBack">
            <i class="fa fa-undo"></i>Volver</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <b-modal ref="importacionModal" 
        title="Importar Participantes"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="modalABM">
      <app-importacion
        :eventoId="parseInt(eventoId)"
        @close="closeImportacion">
      </app-importacion>  
    </b-modal>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import Importacion from './Importacion.vue'
import Filtro from './listFiltro.vue';
import SearchBar from  '../searchList/SearchBar.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs';
import exportXLSParticipantes from '../../mixins/export_xls_participantes';
import moment from 'moment';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'participantes/getField',
  mutationType: 'participantes/updateField',
});

export default {
  name: 'Participantes',
  components: {
    appImportacion: Importacion,
    appFiltro: Filtro,
    appSearchBar: SearchBar,
    appMensaje: Mensaje,
    appConfirm: Confirm,
  },
  mixins: [ 
    msjModal, 
    confirmModal,
    exportXLSParticipantes
  ],
  data: () => {
    return {
      eventoId: 0,

      participantesFields: [
        { 
          key: 'nombreCompleto',
          label: 'Nombre'
        },
        { 
          key: 'documentoNumero',
          label: 'Nro.Documento'
        },
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        },
      ],

      tableBusy: false,
      labelCols: 1,
      editarHabilitado: false,
      borrarHabilitado: false
    }
  },
  computed: {
    ...mapFields([
      'evento',
      'clienteNombre',
      'eventoNombre',
      'tipoEventoId',
      'eventoSorteado',
      'registroManualHabilitado',
      'solicitaCodigoPromocion',
      'participacionNegocios',
      'importaParticipantes',
      'importaGanadores',
      'camposAdicionales',
      'participantesColumnas',

      'tieneImportsPendientes',

      'participantes',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas',
      'nombre',
      'documentoNumero',
      'email',
      'numeroCelular',
      'negocio',
      'cuitNegocio',
      'numeroCliente',
      'codigoPromocion',

      'nombreHabilitado',
      'documentoNumeroHabilitado',
      'emailHabilitado',
      'numeroCelularHabilitado',
      'negocioHabilitado',
      'cuitNegocioHabilitado',
      'numeroClienteHabilitado',
      'codigoPromocionHabilitado'
    ]),
    agregarHabilitado() {
      if ((/true/i).test(this.eventoSorteado)) {
        return false;
      }

      return (/true/i).test(this.registroManualHabilitado);
    },
    numeroClienteHabilitado() {
      let clienteId = parseInt(this.$store.getters['user/admin']);
      if (clienteId == 1) {
        return true;
      }

      return false
    },
  },
  created() {
    this.eventoId = 0;
    if (this.$route.params){
      if (this.$route.params.eventoId){
        this.eventoId = this.$route.params.eventoId;
      }
    }

    if ((/true/i).test(this.$store.getters['user/admin'])) {
      this.editarHabilitado = true;
      this.borrarHabilitado = true;
    }

    this.showSpinner();
    this.$store.dispatch('participantes/inicializar', this.eventoId)
      .then(() => {
        this.formatoGrilla();
        this.getItems();
      })
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner())
  },  
  methods: {
    formatoGrilla() {
      switch (this.tipoEventoId) {
        case 1: /* PWA */
          this.participantesFields = [
            { 
              key: 'nombreCompleto',
              label: 'Nombre'
            },
            { 
              key: 'documentoNumero',
              label: 'Nro.Documento'
            },
            { 
              key: 'fechaNacimiento',
              label: 'Fecha Nacim.'
            },
            { 
              key: 'numeroCelular',
              label: 'Nro.Celular'
            },
            { 
              key: 'confirmado' 
            },
            { 
              key: 'esCliente',
              label: 'Cliente',
              class: 'text-center'
            },
            { 
              key: 'numeroCliente',
              label: 'Nro.Cliente'
            },
            { 
              key: 'staff',
              class: 'text-center'
            },
            {
              key: 'opciones',
              label: '',
              class: 'text-center'
            },
          ]
          break;

        case 2: /* Portal */
          this.participantesFields = [];

          /* Importacion de ganadores (si tiene posición, la mostramos en primer lugar) */
          if ((/true/i).test(this.importaGanadores)) {
            this.participantesFields.push({ 
                  key: 'posicionSorteo',
                  label: 'Posición',
                  class: 'text-right'
                });
          }

          let formatoPropio = false;

          /* ParticipantesColumnas */
          if (this.participantesColumnas) {
            if (this.participantesColumnas.length != 0) {
              formatoPropio = true;

              this.participantesColumnas.forEach(participanteColumna => {
                this.participantesFields.push({ 
                  key: participanteColumna.columna,
                  label: participanteColumna.titulo
                });
              });
            }
          }
          /* CamposAdicionales */
          if (this.camposAdicionales) {
            if (this.camposAdicionales.length != 0) {
              formatoPropio = true;

              this.camposAdicionales.forEach(campoAdicional => {
                if ((/true/i).test(campoAdicional.incluirListado)) {
                  this.participantesFields.push({ 
                    key: `cp${campoAdicional.id}`,
                    label: campoAdicional.campo
                  });
                }
              });
            }
          }

          if (!formatoPropio) {
            if ((/true/i).test(this.solicitaCodigoPromocion)) {
              this.participantesFields.push({
                  key: 'codigoPromocion',
                  label: 'Cod.Promoción'
                });
            }
  
            if ((/true/i).test(this.participacionNegocios)) {
              this.participantesFields.push({
                  key: 'negocio'
                });
              this.participantesFields.push({
                  key: 'negocioCuit',
                  label: 'CUIT'
                });
            } else {
              this.participantesFields.push({ 
                key: 'nombreCompleto',
                label: 'Nombre'
              });
    
              this.participantesFields.push({
                key: 'documentoNumero',
                label: 'Nro.Documento'
              });            
            }
          }

          if ((/true/i).test(this.agregarHabilitado)) {
            this.participantesFields.push({
                key: 'opciones',
                label: '',
                class: 'col-opciones'
              });
          }
          break;
      }
    },
    filtrar(filtro) {
      this.nombre = filtro.nombre.trim();
      this.documentoNumero = filtro.documentoNumero.trim();
      this.email = filtro.email;
      this.numeroCelular = filtro.numeroCelular;
      this.negocio = filtro.negocio;
      this.cuitNegocio = filtro.cuitNegocio;
      this.codigoPromocion = filtro.codigoPromocion.trim();
      this.numeroCliente = filtro.numeroCliente.trim();
      this.paginaActual = 1;
      
      this.getItems();
    },
    getItems() {
      this.tableBusy = true;
      this.$store.dispatch('participantes/getParticipantes')
        .then(() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error));
    },
    editarItem (item) {
      this.$router.push({ name: 'ParticipanteEdit', 
                          params: { 
                            eventoId: this.eventoId, 
                            id: item.id 
                          }});
    },
    consultar (item) {
      this.$router.push({ name: 'ParticipanteDatos', 
                          params: { 
                            eventoId: this.eventoId, 
                            id: item.id 
                          }});
    },
    agregarParticipante () {
      this.$router.push({ name: 'ParticipanteAdd', 
                          params: { 
                            eventoId: this.eventoId
                          }});
    },
    agregarParticipanteReinscripcion () {
      this.$router.push({ name: 'ParticipanteReinscripcion', 
                          params: { 
                            eventoId: this.eventoId
                          }});
    },
    borrarItem (item) {
      this.showModalConfirm('¿Desea borrar el participante del evento?', 
            this.borrarParticipante.bind(this, item.id), 'Si', null, 'No')
    },
    borrarParticipante (participanteId) {
      let params = {
        eventoId: this.eventoId,
        participanteId
      }

      this.showSpinner();
      this.$store.dispatch('participantes/delete', params)
        .then(() => {
          this.showModalMsj('El participante seleccionado se borró con éxito.', null, null, 'light')
          this.getItems();
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner())
    },
    exportParticipantes() {
      this.showSpinner();
      this.$store.dispatch('participantes/getParticipantesList')
        .then(() => {
          let exportar = false;
          let participantes = this.$store.getters['participantes/participantesList'];

          if (participantes) {
            if (participantes.length != 0) {
              exportar = true;
            }
          }

          if (exportar) {
            this.exportXLSParticipantes(this.eventoId, this.evento, participantes);
          } else {
            this.showErrorMsj(new Error('Se produjo un error al recuperar la información de los participantes.'));
          }
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner())
    },
    goBack() {
      this.$router.push({ name: 'Eventos' });
      // this.$router.go(-1);
    },
    importarParticipantes() {
      this.$refs.importacionModal.show();
    },
    closeImportacion(params) {
      console.log(params);
      this.$refs.importacionModal.hide();
      if ((/true/i).test(params.actualizado)) {
        if (params.participantesImportados == 0) {
          this.showErrorMsj(new Error(`No se importaron participantes del listado.`));
        } else {
          this.$router.push({ name: 'ImportsParticipantes', 
                          params: { eventoId: this.eventoId }
                        });

          // this.$router.push({ name: 'ImportParticipantes', 
          //                 params: { 
          //                   eventoId: this.eventoId,
          //                   id: params.importParticipantesId
          //                 }});
        }
      }
    },
    consultarImports() {
      this.$router.push({ name: 'ImportsParticipantes', 
                          params: { eventoId: this.eventoId }
                        });
    }
  },
  watch: {
    'paginaActual' : function(newVal, oldVal) {
      if ( newVal != 0 && oldVal != 0) {
        this.getItems();
      }
    },
  }    
}
</script>

<style>
  /* PWA */
  .eventos-participantes .registro.evento-pwa table td[aria-colindex="1"] {
    width: 18%;
  }
  .eventos-participantes .registro.evento-pwa table td[aria-colindex="2"] {
    width: 10%;
  }
  .eventos-participantes .registro.evento-pwa table td[aria-colindex="3"] {
    width: 10%;
  }
  .eventos-participantes .registro.evento-pwa table td[aria-colindex="4"] {
    width: 10%;
  }
  .eventos-participantes .registro.evento-pwa table td[aria-colindex="5"] {
    width: Calc(17% - 30px);
  }
  .eventos-participantes .registro.evento-pwa table td[aria-colindex="6"] {
    width: 5%;
  }
  .eventos-participantes .registro.evento-pwa table td[aria-colindex="7"] {
    width: 5%;
  }
  .eventos-participantes .registro.evento-pwa table td[aria-colindex="8"] {
    width: 10%;
  }
  .eventos-participantes .registro.evento-pwa table td[aria-colindex="9"] {
    width: 5%;
  }
  .eventos-participantes .registro.evento-pwa table td[aria-colindex="10"] {
    width: 30px;
  }

  .eventos-participantes .registro table td.col-opciones {
    text-align: center;
    width: 30px;
  }

  /* Staff */
  .eventos-participantes tr.table-staff {
    color: var(--primary);
    font-style: italic;
  }
</style>
